import { useTranslation } from 'react-i18next'
import AlertContainer from './AlertContainer'

const LowGPSAccuracyAlert = () => {
  const { t } = useTranslation('others')
  return (
    <AlertContainer
      type="alert"
      alertText={t('lowGpsAccuracyBody')}
      alertColor="orange"
      position="bottom"
      opacity="medium"
      noOverlay
    />
  )
}

export default LowGPSAccuracyAlert
